import AddBankAccount from './AddBankAccount'

export default AddBankAccount
